import { UrlHelper } from "../nautilus/core/html/url-helper";
import { Translator } from "../nautilus/localization/translator";
export class SharedLang {
	//#region Strings
	/** Id "DefaultSettings.Columns.Aktion"
	  * Value "Aktion" */
	public static getDefaultSettingsColumnsAktion(): string {
		return translate("DefaultSettings.Columns.Aktion");
	}
	/** Id "DefaultSettings.Columns.Aktion"
	  * Value "Aktion" */
	public static getDefaultSettingsColumnsAktionOrDefault(defaultValue: string): string {
		return translateOrDefault("DefaultSettings.Columns.Aktion", defaultValue);
	}
	/** Id "DefaultSettings.Columns.Auswahl"
	  * Value "Auswahl" */
	public static getDefaultSettingsColumnsAuswahl(): string {
		return translate("DefaultSettings.Columns.Auswahl");
	}
	/** Id "DefaultSettings.Columns.Auswahl"
	  * Value "Auswahl" */
	public static getDefaultSettingsColumnsAuswahlOrDefault(defaultValue: string): string {
		return translateOrDefault("DefaultSettings.Columns.Auswahl", defaultValue);
	}
	/** Id "DefaultSettings.Columns.InterneId"
	  * Value "Interne Id" */
	public static getDefaultSettingsColumnsInterneId(): string {
		return translate("DefaultSettings.Columns.InterneId");
	}
	/** Id "DefaultSettings.Columns.InterneId"
	  * Value "Interne Id" */
	public static getDefaultSettingsColumnsInterneIdOrDefault(defaultValue: string): string {
		return translateOrDefault("DefaultSettings.Columns.InterneId", defaultValue);
	}
	/** Id "Templates.Remarks.Columns.AnzeigenIn"
	  * Value "Anzeigen in" */
	public static getTemplatesRemarksColumnsAnzeigenIn(): string {
		return translate("Templates.Remarks.Columns.AnzeigenIn");
	}
	/** Id "Templates.Remarks.Columns.AnzeigenIn"
	  * Value "Anzeigen in" */
	public static getTemplatesRemarksColumnsAnzeigenInOrDefault(defaultValue: string): string {
		return translateOrDefault("Templates.Remarks.Columns.AnzeigenIn", defaultValue);
	}
	/** Id "Templates.Remarks.Columns.Bemerkung"
	  * Value "Bemerkung" */
	public static getTemplatesRemarksColumnsBemerkung(): string {
		return translate("Templates.Remarks.Columns.Bemerkung");
	}
	/** Id "Templates.Remarks.Columns.Bemerkung"
	  * Value "Bemerkung" */
	public static getTemplatesRemarksColumnsBemerkungOrDefault(defaultValue: string): string {
		return translateOrDefault("Templates.Remarks.Columns.Bemerkung", defaultValue);
	}
	/** Id "Templates.Remarks.Columns.Ersteller"
	  * Value "Ersteller" */
	public static getTemplatesRemarksColumnsErsteller(): string {
		return translate("Templates.Remarks.Columns.Ersteller");
	}
	/** Id "Templates.Remarks.Columns.Ersteller"
	  * Value "Ersteller" */
	public static getTemplatesRemarksColumnsErstellerOrDefault(defaultValue: string): string {
		return translateOrDefault("Templates.Remarks.Columns.Ersteller", defaultValue);
	}
	/** Id "Templates.Remarks.Columns.ErstelltAm"
	  * Value "Erstellt am" */
	public static getTemplatesRemarksColumnsErstelltAm(): string {
		return translate("Templates.Remarks.Columns.ErstelltAm");
	}
	/** Id "Templates.Remarks.Columns.ErstelltAm"
	  * Value "Erstellt am" */
	public static getTemplatesRemarksColumnsErstelltAmOrDefault(defaultValue: string): string {
		return translateOrDefault("Templates.Remarks.Columns.ErstelltAm", defaultValue);
	}
	/** Id "Templates.Remarks.Columns.Herkunft"
	  * Value "Herkunft" */
	public static getTemplatesRemarksColumnsHerkunft(): string {
		return translate("Templates.Remarks.Columns.Herkunft");
	}
	/** Id "Templates.Remarks.Columns.Herkunft"
	  * Value "Herkunft" */
	public static getTemplatesRemarksColumnsHerkunftOrDefault(defaultValue: string): string {
		return translateOrDefault("Templates.Remarks.Columns.Herkunft", defaultValue);
	}
	/** Id "Templates.Remarks.Columns.Order"
	  * Value "Order" */
	public static getTemplatesRemarksColumnsOrder(): string {
		return translate("Templates.Remarks.Columns.Order");
	}
	/** Id "Templates.Remarks.Columns.Order"
	  * Value "Order" */
	public static getTemplatesRemarksColumnsOrderOrDefault(defaultValue: string): string {
		return translateOrDefault("Templates.Remarks.Columns.Order", defaultValue);
	}
	/** Id "Templates.Remarks.Columns.Sprache"
	  * Value "Sprache" */
	public static getTemplatesRemarksColumnsSprache(): string {
		return translate("Templates.Remarks.Columns.Sprache");
	}
	/** Id "Templates.Remarks.Columns.Sprache"
	  * Value "Sprache" */
	public static getTemplatesRemarksColumnsSpracheOrDefault(defaultValue: string): string {
		return translateOrDefault("Templates.Remarks.Columns.Sprache", defaultValue);
	}
	/** Id "Templates.Remarks.Toolbar.AuchAbgegrenzteAnzeigen"
	  * Value "Auch Abgegrenzte anzeigen" */
	public static getTemplatesRemarksToolbarAuchAbgegrenzteAnzeigen(): string {
		return translate("Templates.Remarks.Toolbar.AuchAbgegrenzteAnzeigen");
	}
	/** Id "Templates.Remarks.Toolbar.AuchAbgegrenzteAnzeigen"
	  * Value "Auch Abgegrenzte anzeigen" */
	public static getTemplatesRemarksToolbarAuchAbgegrenzteAnzeigenOrDefault(defaultValue: string): string {
		return translateOrDefault("Templates.Remarks.Toolbar.AuchAbgegrenzteAnzeigen", defaultValue);
	}
	/** Id "Templates.Remarks.Toolbar.ZuständigkeitHinzufügen"
	  * Value "Zuständigkeit hinzufügen" */
	public static getTemplatesRemarksToolbarZuständigkeitHinzufügen(): string {
		return translate("Templates.Remarks.Toolbar.ZuständigkeitHinzufügen");
	}
	/** Id "Templates.Remarks.Toolbar.ZuständigkeitHinzufügen"
	  * Value "Zuständigkeit hinzufügen" */
	public static getTemplatesRemarksToolbarZuständigkeitHinzufügenOrDefault(defaultValue: string): string {
		return translateOrDefault("Templates.Remarks.Toolbar.ZuständigkeitHinzufügen", defaultValue);
	}
	/** Id "Templates.Responsibility.Columns.Funktion"
	  * Value "Funktion" */
	public static getTemplatesResponsibilityColumnsFunktion(): string {
		return translate("Templates.Responsibility.Columns.Funktion");
	}
	/** Id "Templates.Responsibility.Columns.Funktion"
	  * Value "Funktion" */
	public static getTemplatesResponsibilityColumnsFunktionOrDefault(defaultValue: string): string {
		return translateOrDefault("Templates.Responsibility.Columns.Funktion", defaultValue);
	}
	/** Id "Templates.Responsibility.Columns.GültigVon"
	  * Value "Gültig von" */
	public static getTemplatesResponsibilityColumnsGültigVon(): string {
		return translate("Templates.Responsibility.Columns.GültigVon");
	}
	/** Id "Templates.Responsibility.Columns.GültigVon"
	  * Value "Gültig von" */
	public static getTemplatesResponsibilityColumnsGültigVonOrDefault(defaultValue: string): string {
		return translateOrDefault("Templates.Responsibility.Columns.GültigVon", defaultValue);
	}
	/** Id "Templates.Responsibility.Columns.Mitarbeiter"
	  * Value "Mitarbeiter" */
	public static getTemplatesResponsibilityColumnsMitarbeiter(): string {
		return translate("Templates.Responsibility.Columns.Mitarbeiter");
	}
	/** Id "Templates.Responsibility.Columns.Mitarbeiter"
	  * Value "Mitarbeiter" */
	public static getTemplatesResponsibilityColumnsMitarbeiterOrDefault(defaultValue: string): string {
		return translateOrDefault("Templates.Responsibility.Columns.Mitarbeiter", defaultValue);
	}
	/** Id "Templates.Responsibility.Columns.Zeitraum"
	  * Value "Zeitraum" */
	public static getTemplatesResponsibilityColumnsZeitraum(): string {
		return translate("Templates.Responsibility.Columns.Zeitraum");
	}
	/** Id "Templates.Responsibility.Columns.Zeitraum"
	  * Value "Zeitraum" */
	public static getTemplatesResponsibilityColumnsZeitraumOrDefault(defaultValue: string): string {
		return translateOrDefault("Templates.Responsibility.Columns.Zeitraum", defaultValue);
	}
	//#endregion Strings
	//#region Groups
	/** Id "DefaultSettings.Columns." */
	public static getDefaultSettingsColumns(value: string): string {
		return translate("DefaultSettings.Columns." + value);
	}
	/** Id "DefaultSettings.Columns." */
	public static getDefaultSettingsColumnsOrDefault(value: string, defaultValue: string): string {
		return translateOrDefault("DefaultSettings.Columns." + value, defaultValue);
	}
	/** Id "Templates.Remarks.Columns." */
	public static getTemplatesRemarksColumns(value: string): string {
		return translate("Templates.Remarks.Columns." + value);
	}
	/** Id "Templates.Remarks.Columns." */
	public static getTemplatesRemarksColumnsOrDefault(value: string, defaultValue: string): string {
		return translateOrDefault("Templates.Remarks.Columns." + value, defaultValue);
	}
	/** Id "Templates.Remarks.Toolbar." */
	public static getTemplatesRemarksToolbar(value: string): string {
		return translate("Templates.Remarks.Toolbar." + value);
	}
	/** Id "Templates.Remarks.Toolbar." */
	public static getTemplatesRemarksToolbarOrDefault(value: string, defaultValue: string): string {
		return translateOrDefault("Templates.Remarks.Toolbar." + value, defaultValue);
	}
	/** Id "Templates.Responsibility.Columns." */
	public static getTemplatesResponsibilityColumns(value: string): string {
		return translate("Templates.Responsibility.Columns." + value);
	}
	/** Id "Templates.Responsibility.Columns." */
	public static getTemplatesResponsibilityColumnsOrDefault(value: string, defaultValue: string): string {
		return translateOrDefault("Templates.Responsibility.Columns." + value, defaultValue);
	}
	//#endregion Groups
	public static async intializeAsync() {
		if(!translator) {
			translator = await Translator.fromUrlAsync(UrlHelper.getLocalizationUrl(), null, "Shared", UrlHelper.getCulture());
		}
	}
}
//#region Utility
let translator: Translator | null = null;
function getTranslator() { if (translator) return translator; throw new Error("Translator Shared is not yet initialized") }
function translate(key: string): string { return getTranslator().translate(key); }
function translateOrDefault(key: string, defaultValue: string): string { return getTranslator().translateOrDefault(key, defaultValue);}
//#endregion Utility
